import React, { Component } from "react";
import PropTypes from "prop-types";
import { Typography, Button, Radio, Checkbox, Select, message } from "antd";
import {
  upload,
  createCorporateAccountUser,
  updateCorporateAccountUser,
  deleteFile,
  deleteCorporateUser,
  submitDocumentCorporateAccount
} from "api/api";
import { displayGenericError } from "common/notifications";

import "./DocumentUploadingTab.css";
import UploadWrapper from "./UploadWrapper";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;

const ROLES_MAPPING = {
  director: "Director",
  shareholder: "Shareholder (25% of holding or more)",
  authorizedPerson: "Authorized User"
};

const DOCUMENTS_TYPES_REQUIRED = [
  "CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION",
  "COMPANY_SEARCH_REPORT",
  "MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION",
  "BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
];
const PERSONAL_DOCUMENTS_TYPES_REQUIRED = [
  "IDENTITY_CARD_FRONT",
  "IDENTITY_CARD_BACK",
  "PROOF_OF_ADDRESS"
];

const BOARD_RESOLUTION_TEMPLATE_URL = "https://brdgx-public.s3-ap-southeast-1.amazonaws.com/Resolution_of_the_Board_of_Directors.pdf"

class DocumentUploadingTab extends Component {
  state = {
    persons: [
      {
        director: true,
        shareholder: false,
        authorizedPerson: false,
        nationality: "Singapore",
        idType: "NATIONAL_ID",
        documents: {}
      }
    ],
    proofTradingAddress: true,
    documents: {}
  };

  componentWillReceiveProps({ corporateAccountUsers, corporateAccount }) {
    const { documents } = corporateAccount;
    let proofTradingAddress = true;

    if (!documents["PROOF_OF_BUSINESS_ADDRESS"]) {
      proofTradingAddress = false;
    }

    this.setState({
      persons:
      corporateAccountUsers && corporateAccountUsers.length > 0
        ? this.formatCorporateAccountUsers(corporateAccountUsers)
        : [
          {
            director: true,
            shareholder: false,
            authorizedPerson: false,
            nationality: "Singapore",
            idType: "NATIONAL_ID",
            documents: {}
          }
        ],
      documents,
      proofTradingAddress
    });
  }

  formatCorporateAccountUsers = (corporateAccountUsers = []) => {
    return corporateAccountUsers.map(user => ({
      ...user,
      documents: this.convertAttachedFilesToObj(user.attachedFiles)
    }));
  };

  convertAttachedFilesToObj = (attachedFiles = []) => {
    const response = {};

    attachedFiles.forEach(file => (response[file.attachedFileType] = file));
    return response;
  };

  saveInformation = () => {
    const { persons } = this.state;
    const requests = persons.map(p => {
      return p.id
        ? updateCorporateAccountUser(p)
        : createCorporateAccountUser(p);
    });
    // remove proof of trading address if choose yes
    // if (proofTradingAddress === 1 && documents["PROOF_OF_BUSINESS_ADDRESS"]) {
    //   requests.push(deleteFile(documents["PROOF_OF_BUSINESS_ADDRESS"].id));
    // }
    return Promise.all(requests);
  };

  handleSaveDraft = e => {
    this.saveInformation()
      .then(_ => message.success("Draft saved!"))
      .catch(displayGenericError);
  };

  handleAddPerson = e => {
    this.setState({
      persons: this.state.persons.concat({
        director: false,
        shareholder: false,
        authorizedperson: false,
        nationality: "Singapore",
        idType: "NATIONAL_ID",
        documents: {}
      })
    });
  };

  handleRemovePerson = index => {
    const { persons } = this.state;
    const { id } = persons[index];
    if (typeof id === "number") {
      // call api to remove person
      deleteCorporateUser(id)
        .then(() => {
          persons.splice(index, 1);
          this.setState({ persons });
        })
        .catch(displayGenericError);
    } else {
      persons.splice(index, 1);
      this.setState({ persons });
    }
  };

  handleUpload = ({ file, type, index }) => {
    if (!(typeof index === "number")) {
      return upload({ id: this.props.corporateAccount.id, file, type })
        .then(res => {
          this.setState({
            documents: {
              ...this.state.documents,
              [type]: {
                name: file.name,
                size: file.size / 1024,
                id: res.id
              }
            }
          });
        })
        .catch(displayGenericError);
    } else {
      const { persons } = this.state;
      const { id } = persons[index];

      if (id) {
        this.setState({
          persons
        });
        return upload({ id, isCorporateUsers: true, file, type }).then(res => {
          persons[index].documents = {
            ...persons[index].documents,
            [type]: {
              name: file.name,
              size: file.size / 1024,
              id: res.id
            }
          };
          this.setState({
            persons
          });
          return Promise.resolve();
        });
      } else {
        return createCorporateAccountUser(this.state.persons[index])
          .then(response => {
            persons[index] = {
              ...persons[index],
              id: response.id
            };
            return upload({
              id: response.id,
              isCorporateUsers: true,
              file,
              type
            }).then(res => {
              persons[index].documents = {
                ...persons[index].documents,
                [type]: {
                  name: file.name,
                  size: file.size / 1024,
                  id: res.id
                }
              };
              this.setState({
                persons
              });
              return Promise.resolve();
            });
          })
          .catch(displayGenericError);
      }
    }
  };

  handleRemoveFile = ({ id, type, index }) => {
    deleteFile(id)
      .then(() => {
        if (!(typeof index === "number")) {
          const { documents } = this.state;
          delete documents[type];
          this.setState({ documents });
        } else {
          const { persons } = this.state;
          delete persons[index].documents[type];
          this.setState({ persons });
        }
      })
      .catch(displayGenericError);
  };

  handleSubmit = () => {
    this.saveInformation()
      .then(() => {
        submitDocumentCorporateAccount()
          .then(() => {
            message.info(
              "Thank you for verifying, your account review will be completed soon"
            );
            this.props.nextTab({
              isSubmitted: true,
            });
          })
          .catch(displayGenericError);
      })
      .catch(displayGenericError);
  };

  isSubmitButtonDisabled = () => {
    let response = false;
    const { documents, proofTradingAddress, persons } = this.state;

    if (proofTradingAddress && !documents["PROOF_OF_BUSINESS_ADDRESS"]) {
      return true;
    }

    DOCUMENTS_TYPES_REQUIRED.forEach(type => {
      if (!documents[type]) {
        response = true;
      }
    });

    persons.forEach(person => {
      if (!person.director && !person.shareholder && !person.authorizedPerson) {
        response = true;
      }

      PERSONAL_DOCUMENTS_TYPES_REQUIRED.forEach(type => {
        if (!person.documents[type]) {
          response = true;
        }
      });
    });

    return response;
  };

  renderDownLoadLink = () => {
    const { downLoadLink } = this.props;
    if (
      typeof downLoadLink !== "object" ||
        !downLoadLink.hasOwnProperty("link")
    )
      return null;
    return ;
  };

  renderPerson = (person, index) => {
    const { disabled } = this.props;
    const roles = Object.keys(ROLES_MAPPING)
          .filter(k => person[k])
          .map(k => ROLES_MAPPING[k]);

    return (
      <div className="personWrapper" key={person.id || index}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <Text className="form-title">{`${index + 1}. Person`}</Text>
            <Text className="upload-hint" style={{ marginLeft: 30 }}>
              Select one or multiple options
            </Text>
          </div>
          {index > 0 && !disabled && (
            <Text
              className="remove-person"
              onClick={() => this.handleRemovePerson(index)}
            >
              Remove person
            </Text>
          )}
        </div>
        <br />
        <Checkbox.Group
          disabled={disabled}
          options={Object.values(ROLES_MAPPING)}
          value={roles}
          onChange={roles => {
            const persons = this.state.persons;
            Object.entries(ROLES_MAPPING).forEach(([k, v]) => {
              persons[index][k] = roles.includes(v);
            });
            this.setState({ persons });
          }}
        />
        <br />
        <Text className="form-title">Country</Text>
        <br />
        <Select
          disabled={disabled}
          style={{ width: "50%", marginBottom: 14 }}
          size="large"
          value={person.nationality}
          onChange={value => {
            const persons = this.state.persons;
            persons[index].nationality = value;
            this.setState({ persons });
          }}
        >
          <Option value="Singapore">Singapore</Option>
          <Option value="Australia">Australia</Option>
          <Option value="Hongkong">Hongkong</Option>
        </Select>
        <Radio.Group
          disabled={disabled}
          style={{ marginLeft: 28 }}
          value={person.idType}
          onChange={e => {
            const persons = this.state.persons;
            persons[index].idType = e.target.value;
            this.setState({ persons });
          }}
        >
          <Radio value="NATIONAL_ID">Photo ID</Radio>
          <Radio value="PASSPORT">Passport</Radio>
        </Radio.Group>
        {person.idType === 'NATIONAL_ID' ? (
          <div className="personal-card">
            <UploadWrapper
              disabled={disabled}
              upload={this.handleUpload}
              title="Photo ID (Front)"
              type="IDENTITY_CARD_FRONT"
              file={this.state.persons[index].documents["IDENTITY_CARD_FRONT"]}
              index={index}
              handleRemoveFile={this.handleRemoveFile}
            />
            <UploadWrapper
              disabled={disabled}
              upload={this.handleUpload}
              title="Photo ID (Back)"
              type="IDENTITY_CARD_BACK"
              file={this.state.persons[index].documents["IDENTITY_CARD_BACK"]}
              index={index}
              handleRemoveFile={this.handleRemoveFile}
            />
          </div>
        ) : (
          <UploadWrapper
            disabled={disabled}
            upload={this.handleUpload}
            title="Passport"
            style={{ width: "100%" }}
            type="PASSPORT"
            file={this.state.persons[index].documents["PASSPORT"]}
            index={index}
            handleRemoveFile={this.handleRemoveFile}
          />
        )}
        <Text className="form-title">Proof of Address</Text>
        <br />
        <UploadWrapper
          disabled={disabled}
          upload={this.handleUpload}
          title={null}
          style={{ width: "100%" }}
          type="PROOF_OF_ADDRESS"
          file={this.state.persons[index].documents["PROOF_OF_ADDRESS"]}
          index={index}
          handleRemoveFile={this.handleRemoveFile}
        />
      </div>
  );
};

  render() {
    const { disabled } = this.props;
    return (
      <div className="general-info-tab">
        <div className="left-pane">
          <Title level={4}>Business Document</Title>
          <div className="document-uploading-wrapper">
            <UploadWrapper
              disabled={disabled}
              upload={this.handleUpload}
              file={
                this.state.documents[
                  "CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
                ]
              }
              title="Certificate of Incorporation"
              type="CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
              handleRemoveFile={this.handleRemoveFile}
            />
            <UploadWrapper
              disabled={disabled}
              upload={this.handleUpload}
              file={this.state.documents["COMPANY_SEARCH_REPORT"]}
              title="ACRA Company Profile document"
              type="COMPANY_SEARCH_REPORT"
              handleRemoveFile={this.handleRemoveFile}
            />
            <UploadWrapper
              disabled={disabled}
              upload={this.handleUpload}
              file={
                this.state.documents["MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"]
              }
              title="M&AA or Partnership agreement"
              type="MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"
              handleRemoveFile={this.handleRemoveFile}
            />
            <UploadWrapper
              disabled={disabled}
              upload={this.handleUpload}
              file={this.state.documents["BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"]}
              title="Director's Resolution"
              type="BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
              handleRemoveFile={this.handleRemoveFile}
            >
              <a href={BOARD_RESOLUTION_TEMPLATE_URL} target="_blank" rel="noopener noreferrer">Download Template</a>
            </UploadWrapper>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: 10
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Text className="form-title">Proof of Trading Address </Text>
              <Text className="upload-hint">
                <Checkbox
                  checked={!this.state.proofTradingAddress}
                  disabled={disabled}
                  onChange={e => this.setState({ proofTradingAddress: !e.target.checked })}
                  style={{ marginRight: '0.5rem' }}
                />
                My trading address is the same as my registered address.
              </Text>
            </div>
          </div>
          {this.state.proofTradingAddress && (
            <UploadWrapper
              disabled={disabled}
              style={{ width: "100%" }}
              upload={this.handleUpload}
              type="PROOF_OF_BUSINESS_ADDRESS"
              file={this.state.documents["PROOF_OF_BUSINESS_ADDRESS"]}
              handleRemoveFile={this.handleRemoveFile}
            />
          )}

          <Title level={4}>Personal Document</Title>
          <Text className="upload-hint">
            Please provide personal documents for Directors, Shareholders and Authorized Users
          </Text>
          <p/>

          {this.state.persons.map(this.renderPerson)}

          <div
            style={{
              marginBottom: "1rem",
              padding: "1rem 0",
              borderTop: "1px solid #ddd",
              borderBottom: "1px solid #ddd"
            }}
          >
            {!disabled && (
              <span
                style={{ color: "#3D77BC", cursor: "pointer" }}
                onClick={this.handleAddPerson}
              >
                + Add person
              </span>
            )}
          </div>
          <div className="button-wrapper">
            <Button className="bt-skip" onClick={this.props.prevTab}>
              Back
            </Button>
            {!disabled && (
              <Button className="bt-skip" onClick={this.handleSaveDraft}>
                Save as Draft
              </Button>
            )}
            {!disabled && (
              <Button
                className="bt-next"
                type="primary"
                onClick={this.handleSubmit}
                disabled={this.isSubmitButtonDisabled()}
              >
                Submit
              </Button>
            )}
          </div>
        </div>
        <div className="right-pane">
          <Text className="guide-title">Company Details</Text>
          <Paragraph className="guide-para">
            We are required to collect your company name for verification purposes.
          </Paragraph>

          <Paragraph className="guide-para">
            Supported file types: PDF, Word, JPG, JPEG, PNG, BMP up to 10MB.
          </Paragraph>
        </div>
      </div>
  );
  }
}

DocumentUploadingTab.propTypes = {
  nextTab: PropTypes.func
};

export default DocumentUploadingTab;
